<template lang="pug">
.page.page-quotes
  .container.py-5
    h1.page-title {{ $t('quotesPage.title') }}
    p.page-subtitle {{ $t('quotesPage.subtitle') }}

    .quotes-grid
      .quote-tile(v-for="(q, i) in quotesList", :key="i")
        .quote-mark ❝
        p.quote-text(v-html="q.text")
        .quote-meta
          span.quote-source {{ q.source }}
          span.quote-year(v-if="q.year") · {{ q.year }}

    .footer-back
      router-link.back-link(:to="localizedPath('/about')") ← {{ $t('quotesPage.backToAbout') }}
    site-links
</template>

<script>
import SiteLinks from '@/components/ui/SiteLinks.vue'
import { withSlash } from '@/runtime/site-path.mjs'
import { useI18n } from 'vue-i18n'

export default {
  components: { SiteLinks },
  name: 'PageQuotes',
  setup() {
    const { locale } = useI18n()
    const localizedPath = (path) => withSlash(locale.value === 'zh' ? '/zh' + path : path)
    return { localizedPath }
  },
  computed: {
    quotesList() { return this.$tm('quotesPage.quotes') || [] }
  }
}
</script>

<style lang="sass">
.page-quotes
  background-color: var(--bg0)
  color: var(--ink)
  min-height: 100vh

  .container
    max-width: var(--content-w)

  .page-title
    font-size: 2rem
    text-align: center
    margin-bottom: 8px

  .page-subtitle
    text-align: center
    color: var(--ink-3)
    margin-bottom: 48px
    font-size: 1.05rem

  .quotes-grid
    display: grid
    grid-template-columns: repeat(2, 1fr)
    gap: 20px
    @media (max-width: 768px)
      grid-template-columns: 1fr

  // 引句牆：無框面板，一枚金色引號懸在左上；hover 只換底色，不位移
  .quote-tile
    position: relative
    padding: 44px 36px 28px 52px
    text-align: left
    border-radius: var(--r-lg)
    background: var(--bg1)
    transition: var(--t-hover)
    &:hover
      background: var(--bg2)
    @media (max-width: 575px)
      padding: 40px 24px 24px 40px

  .quote-mark
    position: absolute
    top: 20px
    left: 18px
    font-family: Georgia, 'Times New Roman', serif
    font-size: 0
    line-height: 1
    color: var(--gold)
    opacity: 0.85
    &::before
      content: '\201C'
      font-size: 3rem

  .quote-text
    font-family: var(--font-display)
    font-size: 1.15rem
    line-height: 1.85
    color: var(--ink)
    margin: 0 0 22px 0
    position: relative
    z-index: 1

  .quote-meta
    font-size: 0.82rem
    color: var(--ink-4)
    letter-spacing: 0.06em

  .quote-source
    color: var(--ink-3)

  .footer-back
    text-align: center
    margin-top: 48px
</style>
